import { getVisitorId, sendBeaconJson } from "@/lib/analytics";

/**
 * Impression/view beacons for events -- same fire-and-forget convention as
 * lib/analytics.js's trackPageVisit (reuses its per-browser visitor_id), feeding
 * BookingController::stats()'s impressionsCount/viewsCount/viewsSeries that event owners see
 * on their per-event stats page.
 *
 * "impression" = a card actually scrolled into view in a listing/carousel (true viewport
 * visibility via IntersectionObserver -- see useEventImpression below), not just mounted in the
 * DOM. "view" = the event details page opened.
 */
const ENDPOINT = "/api/public/events/engagement/track";

function track(eventId, type) {
  if (typeof window === "undefined" || !eventId) return;
  const visitorId = getVisitorId();
  if (!visitorId) return;
  sendBeaconJson(ENDPOINT, { event_id: eventId, type, visitor_id: visitorId });
}

export function trackEventImpression(eventId) {
  track(eventId, "impression");
}

export function trackEventView(eventId) {
  track(eventId, "view");
}
